import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() collectionSize: number;

  private _page: number = 1;
  @Input()
  get page(): number {
    return this._page;
  }
  set page(pageNumber: number) {
    this._page = pageNumber;
  }

  @Input() maxSize: number = 4;

  private _allData: any;
  @Input()
  get allData(): any {
    return this._allData;
  }
  set allData(allData: any) {
    this._allData = (!!allData && allData) || null;
    this.loadPage(this.page);
  }

  @Input() float: 'left' | 'right' = 'left';
  @Input() pageSize: number = 4;

  @Output() listPagination = new EventEmitter();

  private lowerIndex: any;
  private upperIndex: any;
  private listToDisplay = [];

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['allData']){
      this.page = 1;
      this.loadPage(this.page);
    }
  }

  loadPage(selectedPage: number) {

    if (selectedPage <= this.collectionSize && selectedPage > 0) {
      this.page = selectedPage;
      this.lowerIndex = this.pageSize * (selectedPage - 1);
      this.upperIndex = this.lowerIndex + this.pageSize;
      this.listToDisplay = this.allData.slice(this.lowerIndex, this.upperIndex);
    } else {
      this.listToDisplay = [];
    }

    this.listPagination.emit(this.listToDisplay);
  }
}
